import React, { useEffect, useState } from 'react';
import './styles.css';

const App = () => {
  const [resume, setResume] = useState(null);

  useEffect(() => {
    fetch('/api/resume')
      .then(response => response.json())
      .then(data => setResume(data));
  }, []);

  if (!resume) {
    return <div className="loading">Loading...</div>;
  }

  return (
    <div className="resume-container">
      <header>
        <h1>
          {resume.name.split(' (')[0]}
          {resume.name.includes(' (') && (
            <span className="title-specialty">({resume.name.split(' (')[1]}</span>
          )}
        </h1>
      </header>
      <section>
        <h2>Summary</h2>
        <p>{resume.summary}</p>
      </section>
      <section>
        <h2>Skills</h2>
        <ul class="skills">
          {resume.skills.map((skill, index) => <li key={index}>{skill}</li>)}
        </ul>
      </section>
      <section>
        <h2>Experience</h2>
        {resume.experience.map((job, index) => (
          <div key={index} className="job">
            <h3>{job.role} - {job.company}</h3>
            <p>{job.duration}</p>
            <ul>
              {job.highlights.map((highlight, idx) => <li key={idx}>{highlight}</li>)}
            </ul>
          </div>
        ))}
      </section>
      <section>
        <h2>Education</h2>
        {resume.education.map((edu, index) => (
          <p key={index}>{edu.degree}, {edu.institution} ({edu.year})</p>
        ))}
      </section>
      <section>
        <h2>Certifications</h2>
        <ul>
          {resume.certifications.map((cert, index) => <li key={index}>{cert}</li>)}
        </ul>
      </section>
    </div>
  );
};

export default App;
